import ReactOnRails from 'react-on-rails/client'
import ReactModal from 'react-modal'
import axios from 'axios'
import 'whatwg-fetch'
import smoothscroll from 'smoothscroll-polyfill'

import 'react-day-picker/style.css'
import 'react-phone-number-input/style.css'
import 'rc-slider/assets/index.css'

import '../helpers/isomorphic'
import '../helpers/pluralize'

import App from '../App'
import ShowMoreText from '../components/ShowMoreText'
import Footer from '../layout/Footer'
import { initClient as initClientI18n } from '../i18n'
import createRenderer from './createRenderer'
import reportWebVitals from './webVitals'

axios.defaults.baseURL = '/api'

initClientI18n()

// https://github.com/reactjs/react-modal/issues/576
ReactModal.setAppElement('body')

smoothscroll.polyfill()

// Field Core Web Vitals → Segment (main thread; client entry only)
reportWebVitals()

ReactOnRails.register({
  // App and Footer expose 2-arg factories that return a `() => element`
  // closure on the client. createRenderer takes a 3-arg shape so
  // react-on-rails treats us as an `isRenderer` and skips its internal
  // hydrateRoot call — see client/src/startup/createRenderer.tsx.
  App: createRenderer((props, railsContext) => App(props, railsContext)()),
  Footer: createRenderer((props, railsContext) =>
    Footer(props, railsContext)(),
  ),
  ShowMoreText: createRenderer((props) => <ShowMoreText {...props} />),
})
